export const applyLimit = (collection, limit) => {
  if (!collection || !limit || collection.length <= limit) {
    return collection
  }

  return collection.slice(0, limit)
}
